/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 30.06.2016
 */
'use strict';

import L from 'external/leaflet';
import '../css/display-coordinates-plugin-popup.scss';

export default class DisplayCoordinatesPlugin {
    constructor(props, config) {
        this.config = config;
        this.props = props;

        this.active = false;
        this.latlng = undefined;

        this.toggleActive = this.toggleActive.bind(this);
        this.getCoordinates = this.getCoordinates.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    init(map, o) {
        this._map = map;
        this.popup = L.popup({ autoClose: false, interactive: true });
        this.popupContent = L.DomUtil.create('btn', 'btn display-coordinates-plugin-popup');
        this.popupContentTextNode = L.DomUtil.create('span', 'display-coordinates-plugin-popup__text', this.popupContent);
        this.copyButton = L.DomUtil.create('btn', 'display-coordinates-plugin-popup__icon fa fa-clipboard', this.popupContent);

        L.DomEvent.addListener(this.popupContent, 'click', this.copyToClipboard);

        this.popup.setContent(this.popupContent);

        this.coordinatesControlTemplate = L.Control.extend({
            options: {
                position: 'topleft'
            },

            onAdd: (map) => {
                this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                this.icon = L.DomUtil.create('span', 'fa fa-crosshairs', this.container);
                this.container.setAttribute('title', 'Koordinatenabfrage');
                this.container.setAttribute('role', 'button');

                L.DomEvent.on(this.container, 'click', this.toggleActive, this);
                return this.container;

            }
        });
        this.coordinatesControl = new this.coordinatesControlTemplate();
        map.addControl(this.coordinatesControl);
    }

    toggleActive(e) {
        if (e) {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
        }

        if (this.active) {
            this.active = false;
            this._map.blockingControlActive = false;
            this.container.classList.remove('active');
            this._map.off('click', this.getCoordinates);
            this.popup.remove();
            return;
        }
        if (this._map.blockingControlActive) {
            return;
        }
        this.active = true;
        this._map.blockingControlActive = true;
        this.container.classList.add('active');
        this._map.on('click', this.getCoordinates);
    }

    copyToClipboard() {
        if (navigator.clipboard) {
            navigator.clipboard
                .writeText(`${ this.latlng.lat.toFixed(5) }, ${ this.latlng.lng.toFixed(5) }`)
                .then(() => {
                    this._map.toast.success('', 'Koordinaten erfolgreich in die Zwischenablage kopiert!');
                })
                .catch(e => {
                    this._map.toast.alert('', 'Kopieren der Koordinaten fehlgeschlagen!');
                })

        }
    }

    getCoordinates(e) {
        this.toggleActive();
        const { latlng } = e;
        this.latlng = latlng;
        this.popupContentTextNode.innerHTML = `Lat: ${ latlng.lat.toFixed(5) } </br> Lon: ${ latlng.lng.toFixed(5) }`;
        this.popup.setLatLng(latlng).openOn(this._map);
    }

    remove() {
        L.DomEvent.removeListener(this.popupContent, 'click', this.copyToClipboard);
        this.popup = null;
        this._map = null;
    }
}



// WEBPACK FOOTER //
// ./js/plugins/DisplayCoordinatesPlugin.js